import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronRightOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m17.273 12-8 8L8 18.727 14.727 12 8 5.273 9.273 4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronRightOutlinedSize24Glyph.displayName = 'ChevronRightOutlinedSize24Glyph';
